import { PlcState } from './types'

export const state: PlcState = {
  plcs: [],
}
